import { getWorkOrderDrawings } from "@/pages/work-orders/repositorie/WorkOrdersRepositorie";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { get } from "lodash-es";

type Props = {
	setIsWorkOrderDrawingsLoading: (isLoading: boolean) => void;
	setWorkOrderDrawingsError: (err: string) => void;
	WorkOrderId: number | null;
};

export const useSearchWorkOrderDrawings = ({
	setIsWorkOrderDrawingsLoading,
	setWorkOrderDrawingsError,
	WorkOrderId,
}: Props) => {
	const {
		state: {},
		actions: { setWorkOrderDrawingsList },
	} = useWorkOrderModalsContext();

	return async () => {
		setWorkOrderDrawingsList([]);
		setIsWorkOrderDrawingsLoading(true);
		const res = await getWorkOrderDrawings(WorkOrderId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setWorkOrderDrawingsList(rowsSource);
			setIsWorkOrderDrawingsLoading(false);
		} else {
			setIsWorkOrderDrawingsLoading(false);
			setWorkOrderDrawingsError(res.message);
		}
	};
};
